'use client';

import NumberFlow from '@number-flow/react';
import Decimal from 'decimal.js';
import { useEffect, useRef } from 'react';
import { Numeric } from '@/lib/types/common';

interface AnimatedCentTextProps {
  value: Numeric;
  decimals?: number;
  className?: string;
}

export function AnimatedCentText({ value, decimals = 0, className }: AnimatedCentTextProps) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const centValue = Number(new Decimal(value).mul(100));

  return (
    <NumberFlow
      value={centValue}
      suffix="¢"
      format={{
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }}
      locales="en-US"
      animated={!isFirstRender.current}
      className={className}
      willChange
    />
  );
}
